import { useTranslation } from 'react-i18next'
import { Text, IconCheckCircleOutline, Box } from '@machobear/design-system'
import { InsightBlock } from '../insight-block'

export const VerificationCompleted = () => {
  const { t } = useTranslation()

  return (
    <InsightBlock
      testId="verify-listing"
      icon={<IconCheckCircleOutline tone="positive" size="small" />}
    >
      <Box display="flex" flexDirection="column" justifyContent="center" style={{ height: '21px' }}>
        <Text size="medium" weight="medium">
          {t('Verify your listing')}
        </Text>
      </Box>
    </InsightBlock>
  )
}
